import { Transition } from '@headlessui/react'
import { FloppyDisk } from 'iconoir-react'
import Spinner from 'app/components/Spinner'

export type FloatingSaveComponentProps = {
  visible: boolean
  isSaving: boolean
  buttonType: 'button' | 'submit'
  buttonLabel: string
  onSave: (() => void) | undefined
}

export function FloatingSaveComponent({
  visible,
  isSaving,
  buttonType,
  buttonLabel,
  onSave,
}: FloatingSaveComponentProps) {
  return (
    <Transition
      show={visible}
      enter="transition-opacity duration-300"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-300"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed bottom-8 left-1/2 -translate-x-1/2 translate-y-0 transform opacity-100 transition-all duration-300">
        <div className="rounded-2xl border border-default bg-surface-raised p-6 shadow-xl backdrop-blur-sm">
          <div className="flex items-center justify-between gap-6">
            <div className="flex-1">
              <h3 className="text-lg font-semibold text-strong">Unsaved Changes</h3>
              <p className="text-sm text-subtle">You have unsaved changes that will be lost if you leave this page.</p>
            </div>
            <button
              type={buttonType}
              onClick={onSave}
              className="flex min-w-[140px] items-center justify-center gap-3 rounded-xl bg-blue-600 px-6 py-3 text-sm font-medium text-on-color transition-all duration-200 hover:scale-105 hover:bg-blue-700 hover:shadow-lg active:scale-95 disabled:bg-blue-200"
              disabled={isSaving}
            >
              {isSaving ? <Spinner size={6} /> : <FloppyDisk className="h-5 w-5" />}
              {isSaving ? `Saving...` : buttonLabel}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  )
}
